import { Navigate, useLocation } from "react-router-dom";

/** Keeps bookmarked filters and entity context intact while a route is regrouped. */
export function LegacyRouteRedirect({ to }: { to: string }) {
  const location = useLocation();
  return (
    <Navigate
      to={`${to}${location.search}${location.hash}`}
      relative="path"
      replace
    />
  );
}
